<template>
  <div>
    <Navbar ref="navbar" />
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">{{ t('profileTitle', 'profileTitle')}}</h6>
          <div class="element-box">
            <div class="row align-items-center">
              <div class="col-sm-12">
                <div class="element-info-text">
                  <h5 class="element-inner-header profile-header"><i class="os-icon os-icon-settings"></i> {{ t('profileSettings', 'profileSettings')}}</h5>
                </div>
                <hr>
                <div class="profile-tile">
                  <a class="profile-tile-box">
                    <div class="pt-avatar-w">
                      <img v-if="getUserDetails.profilePicture" :src="getUserDetails.profilePicture + '?' + this.cacheValue" class="user-pic" alt="profile picture">
                      <img v-else src="@/assets/person.png" alt="profile picture">
                    </div>
                    <b-form-file accept=".jpg, .png" id="userPictureInput" @change="updateUserPicture" v-model="userPicture" hidden style="display: none;"></b-form-file>
                    <span class="user-pic-btn" @click="chooseFile()">Update</span>
                  </a>
                  <div class="profile-tile-meta">
                    <ul>
                      <li v-if="getUserDetails.username"><i class="os-icon os-icon-user-male-circle"></i><strong>{{ t('profileSettingsMetaUsername', 'profileSettingsMetaUsername')}}</strong> <span>{{getUserDetails.username}}</span></li>
                      <li v-if="getUserDetails.name"><i class="os-icon os-icon-user"></i> <strong>{{ t('profileSettingsMetaName', 'profileSettingsMetaName')}}</strong> <span>{{getUserDetails.name}}</span></li>
                      <li v-if="getUserDetails.telephone"><i class="os-icon os-icon-phone"></i> <strong>{{ t('profileSettingsMetaTelephone', 'profileSettingsMetaTelephone')}}</strong> <span>{{getUserDetails.telephone}}</span></li>
                      <li v-if="getUserDetails.fax"><i class="os-icon os-icon-printer"></i> <strong>{{ t('profileSettingsMetaFax', 'profileSettingsMetaFax')}}</strong> <span>{{getUserDetails.fax}}</span></li>
                      <li><i class="os-icon os-icon-mail-01"></i> <strong>{{ t('profileSettingsMetaEmail', 'profileSettingsMetaEmail')}} </strong> <span>{{getUserDetails.email}}</span></li>
                    </ul>
                  </div>
                  <ResponseInfo v-if="getResponseInfo.responseName == 'userProfilePicture'" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <ProfileFormEmail />
          <ProfileFormPassword />
          <ProfileFormInfo />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Helper_Components/Footer'
import ResponseInfo from '@/components/ResponseInfo'
import { mapGetters } from 'vuex'
import ProfileFormEmail from '@/components/Profile/ProfileFormEmail.vue'
import ProfileFormPassword from '@/components/Profile/ProfileFormPassword.vue'
import ProfileFormInfo from '@/components/Profile/ProfileFormInfo.vue'

export default {
  name: 'profile',
  data() {
    return {
      userPicture: null,
      cacheValue: new Date().getTime()
    }
  },
  computed:{
      ...mapGetters(['allTemplateDetails', 'getUserDetails','getIsNewsnet', 'getResponseInfo'])
  },
  components: {
      Navbar,
      ResponseInfo,
      ProfileFormEmail,
      ProfileFormPassword,
      ProfileFormInfo,
      Footer
  },
  methods: {
    chooseFile() {
      document.getElementById("userPictureInput").click()
    },
    update() {
      this.cacheValue = new Date().getTime()
    },
    updateUserPicture(event) {
      this.userPicture = event.target.files[0]

      let formData = new FormData();
      formData.append('userPicture', this.userPicture)
      formData.append('userId', this.getUserDetails.id)
      this.$store.dispatch('updateUserPicture',formData).then(() => {
        // after 1 sec we update the cached url to make sure we get the image that was just uploaded
        setTimeout( () => {
          this.update()
          this.$refs.navbar.update()
        } , 1000)
      })
    }
  }
}
</script>

<style>
  h5 i{
    color: #047bf8;
  }
  .profile-tile-box{
    cursor: pointer;
    position: relative;
    opacity: 1;
    transition: .5s ease;
    backface-visibility: hidden;
  }
  .profile-tile-meta ul{
    display: flex;
    flex-wrap: wrap;
  }
  .profile-tile-meta ul li{
    font-size: 0.7rem;
    margin-bottom: 0;
    padding: 10px;
  }
  .profile-tile-meta ul li i{
    color: #047bf8;
    font-size: large;
    vertical-align: bottom;
  }
  .profile-tile-meta ul li span{
    display: block;
    padding-left: 22px;
  }
  .user-pic {
    height: 60px;
    width: 60px;
    max-width: 100%;
    max-height: 100%;
  }
  .user-pic-btn {
    background: #047bf8;
    padding: 5px;
    color: white;
    border-radius: 5px;
    transition: .5s all ease;
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    text-align: center;
    font-size: 12px;
  }
  .pt-avatar-w {
    width: 60px;
    height: 60px;
    max-height: 60px;
    max-width: 60px;
    transition: .5s ease;
  }
  .profile-tile-box:hover .pt-avatar-w {
    opacity: 0.4;
  }
  .profile-tile-box:hover .user-pic-btn {
    background: #047bf8;
    opacity: 1;
  }
</style>
